import assetsList, { asset as ethereum } from '@exodus/ethereum-meta'
import { Tx } from '@exodus/models'

import { MaticStakingApi } from './api.js'

// function selector for buyVoucher(uint256 _amount, uint256 _minSharesToMint)
const DELEGATE = '0x6ab15071'
// function selector for sellVoucher_new(uint256 claimAmount, uint256 maximumSharesToBurn)
const UNDELEGATE = '0xc83ec04d'
// function selector for withdrawRewards()
const CLAIM_REWARD = '0xc7b8981c'
// function selector for unstakeClaimTokens_new(uint256 unbondNonce)
const CLAIM_UNDELEGATE_BALANCE = '0xe97fddc2'

const STAKING_MANAGER_CONTRACT = MaticStakingApi.STAKING_MANAGER_ADDR

const METHOD_ID_CHAR_LENGTH = 10

const { currency: polygonCurrency } = assetsList.find(
  ({ name: tokenName }) => tokenName === 'polygon'
)
const currencies = { ethereum: ethereum.currency, polygon: polygonCurrency }

export const isPolygonTx = ({ coinName }) => coinName === 'polygon'
export const isPolygonDelegate = (tx) =>
  isPolygonTx(tx) && tx.to === STAKING_MANAGER_CONTRACT && tx.data?.methodId === DELEGATE
export const isPolygonUndelegate = (tx) =>
  isPolygonTx(tx) && tx.from?.[0] === STAKING_MANAGER_CONTRACT && tx.data?.methodId === UNDELEGATE
export const isPolygonReward = (tx) =>
  isPolygonTx(tx) && tx.from?.[0] === STAKING_MANAGER_CONTRACT && tx.data?.methodId === CLAIM_REWARD
export const isPolygonClaimUndelegate = (tx) =>
  isPolygonTx(tx) &&
  tx.from?.[0] === STAKING_MANAGER_CONTRACT &&
  tx.data?.methodId === CLAIM_UNDELEGATE_BALANCE

const isPolygonStakingContractTxInEthereumTxLog = (tx) =>
  tx.to === MaticStakingApi.EVERSTAKE_VALIDATOR_CONTRACT_ADDR

const isPolygonStakingContractCallInEthTx = ({ tx, methodId }) =>
  tx?.data?.data?.slice?.(0, Math.max(0, METHOD_ID_CHAR_LENGTH)) === methodId // ETH txs have contract data in 'data'

const isPolygonUndelegateTxInEthreumTxLog = (tx) =>
  isPolygonStakingContractCallInEthTx({ tx, methodId: UNDELEGATE })

// Some polygon unstake txs are only kept in the ETH tx log rather than Polygon tx log.
// This is b/c the given tx does not have any ERC2O token transfer (MATIC).
// Token tx log only has txs which contains ERC2O token transfer of the given token.
export const isPolygonUndelegateTxInEthereumTxLog = (tx) =>
  isPolygonStakingContractTxInEthereumTxLog(tx) && isPolygonUndelegateTxInEthreumTxLog(tx)

export const createUndelegateTx = (tx) => {
  return Tx.fromJSON({
    ...tx,
    coinName: 'polygon',
    coinAmount: currencies.polygon.ZERO,
    tokens: [],
    currencies,
    from: [STAKING_MANAGER_CONTRACT],
  })
}

export const getPolygonUndelegateTxInEthereumTxLog = (ethereumLogItems) => {
  if (!ethereumLogItems || ethereumLogItems.length === 0) return []

  const polygonLogItems = []
  const polygonEthUndelegateTxs = [...ethereumLogItems].filter((tx) =>
    isPolygonUndelegateTxInEthereumTxLog(tx)
  )
  const polygonUndelegateTxs = [...polygonEthUndelegateTxs].map((tx) => createUndelegateTx(tx))

  for (const polygonTx of polygonUndelegateTxs) {
    polygonLogItems.push(polygonTx)
  }

  polygonLogItems.sort((a, b) => new Date(b.date) - new Date(a.date))

  return polygonLogItems
}
